import React from "react";
import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import IaMessage from "./IaMessage";
import { IaHero } from "./IaLogo";

/**
 * Fil de la conversation.
 *
 * `flex-column-reverse` sur un conteneur scrollable colle automatiquement la vue
 * en bas quand un message arrive : c'est le procede deja utilise par le chat SAV,
 * il evite toute gestion manuelle de scrollTo pendant le streaming.
 */
const IaMessageList = () => {
  const { t } = useTranslation("common");
  const { messages, messagesLoading, streamingMessageId, streamingText } =
    useSelector((state) => state.iaReducer);

  if (messagesLoading) {
    return (
      <div className="alignC flex-grow-1">
        <span className="f14 normal text-lightBlack">{t("Loading")}...</span>
      </div>
    );
  }

  if (!messages.length) {
    return (
      // overflow-auto : sur un ecran court, le visuel et le message d'accueil
      // defilent au lieu de pousser le composer hors du tiroir.
      <div className="iaEmptyState alignC flex-column flex-grow-1 overflow-auto customScroll px-4 py-3 gap-3">
        <IaHero />
        <div className="iaWelcomeCard br5 px-3 py-3">
          <p className="f14 sBold text-white mb-2">{t("Welcome dear partner,")}</p>
          <p className="f13 normal text-white mb-2">
            {t(
              "I am an expert on every model and can help you find commercial arguments; I take care of the sales techniques to close your deals. I know the prices for margin calculation, and also the right questions to ask when gathering information."
            )}
          </p>
          <p className="f13 normal text-white mb-0">
            {t("For your information, I handle one product per conversation.")}
          </p>
        </div>
      </div>
    );
  }

  return (
    <div className="iaMessageList d-flex flex-column-reverse overflow-auto flex-grow-1 customScroll px-3 pt-3">
      {/* Les messages restent dans l'ordre chronologique a l'interieur de ce
          conteneur : c'est le flex-column-reverse du parent qui ancre le scroll
          en bas, sans inverser l'affichage. */}
      <div className="d-flex flex-column">
        {messages.map((message) => (
          <IaMessage
            key={message.id}
            message={message}
            streamingText={streamingText}
            isStreaming={message.id === streamingMessageId}
          />
        ))}
      </div>
    </div>
  );
};

export default IaMessageList;
